module.exports = __webpack_public_path__ + "img/metamask.bb8dadc2.svg";